import React from 'react';
import {
  List,
  ListItem,
  ListProps,
  Theme,
  withStyles,
} from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';
import { purple } from 'globals/colors';

export const Caption = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[300],
  },
}))(FsCaption);

export const StyledList = withStyles(() => ({
  root: {
    padding: 0,
  },
}))((props: ListProps & { component: string }) => <List {...props} />);

export const StyledListItem = withStyles(({ spacing }: Theme) => ({
  root: {
    borderRadius: spacing(0.5),
    '&.Mui-selected': {
      backgroundColor: purple.V4,
      color: purple.BRAND,
      '& span': {
        fontWeight: `600!important`,
      },
    },
    '&.Mui-selected:hover': {
      backgroundColor: purple.V4,
    },
  },
}))(ListItem);

export default {
  Caption,
};
